var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19527 10.4716C4.13336 10.4097 4.08425 10.3362 4.05075 10.2553C4.01724 10.1744 4 10.0877 4 10.0002C4 9.91265 4.01724 9.82595 4.05075 9.74507C4.08425 9.66418 4.13336 9.59069 4.19527 9.52878L8.39061 5.33344L4.19527 1.13827C4.07025 1.01324 4.00001 0.843667 4.00001 0.666851C4.00001 0.490036 4.07025 0.320462 4.19527 0.195434C4.3203 0.0704066 4.48987 0.000166577 4.66669 0.000166575C4.84351 0.000166574 5.01308 0.0704066 5.13811 0.195434L9.80478 4.86211C9.92978 4.98718 10 5.15678 10 5.33361C10 5.51044 9.92978 5.68003 9.80478 5.80511L5.13811 10.4718C5.00794 10.6018 4.83727 10.6668 4.66677 10.6668C4.49627 10.6668 4.32544 10.6018 4.19527 10.4716ZM0.666768 10.6668C0.837268 10.6668 1.00793 10.6018 1.1381 10.4716L5.80477 5.80494C5.92978 5.67987 5.99999 5.51027 5.99999 5.33344C5.99999 5.15661 5.92978 4.98702 5.80477 4.86194L1.1381 0.195267C1.01307 0.0702397 0.8435 -1.31738e-09 0.666685 0C0.489869 1.31738e-09 0.320295 0.0702397 0.195267 0.195267C0.0702397 0.320295 1.31738e-09 0.489869 0 0.666685C-1.31738e-09 0.843501 0.0702397 1.01307 0.195267 1.1381L4.39061 5.33344L0.195434 9.52878C0.102228 9.62201 0.0387564 9.74079 0.0130447 9.87009C-0.012667 9.99939 0.000535146 10.1334 0.0509819 10.2552C0.101429 10.377 0.186855 10.4811 0.296462 10.5544C0.406069 10.6276 0.534934 10.6668 0.666768 10.6668Z",
    fill: "#8D8D8D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/doubleArrow.6e0a57e8039555b23629a6a2915c31d2.svg";
export { ForwardRef as ReactComponent };